import { render, staticRenderFns } from "./Information_Component.vue?vue&type=template&id=ca6e85de&scoped=true&"
import script from "./Information_Component.vue?vue&type=script&lang=js&"
export * from "./Information_Component.vue?vue&type=script&lang=js&"
import style0 from "./Information_Component.vue?vue&type=style&index=0&id=ca6e85de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6e85de",
  null
  
)

export default component.exports